export const ATTEMPTS_RECEIVED = "ATTEMPTS_RECEIVED";
export const SET_SINGLE_ATTEMPT = "SET_SINGLE_ATTEMPT";
export const SET_UPDATE = "SET_UPDATE";
